import React, { useCallback, useEffect, useState } from 'react';
import '@patternfly/react-styles/css/utilities/Sizing/sizing.css';
import _ from 'lodash';

import SimpleTable, { SortDirection, RowSelection } from 'components/Common/SimpleTable/SimpleTable';
import { useTranslation } from 'localization/useTranslation';
import Tl from 'localization/LocalizationKeys';

const columns = [
  {
    label: Tl.common.name,
    path: 'displayName',
    isSortable: true,
    searchItem: true
  },
  {
    label: Tl.model.version,
    path: 'id',
    isSortable: true,
    searchItem: true
  }
];

const DefaultSortBy = {
  path: 'displayName',
  direction: SortDirection.DESC
};

const NewModelStep = ({ models, migrationInfo, setMigrationInfo, setIsValid }) => {
  const T = useTranslation();
  const [hasError] = useState(false);
  const [selectedModel, setSelectedModel] = useState(_.filter(models, model => model.id === migrationInfo.targetModel?.id));

  const onSelectedRows = useCallback((models) => {
    setSelectedModel(models);
    setMigrationInfo(oldInfo => ({
      ...oldInfo,
      targetModel: _.first(models),
      bindingMap: undefined,
      assetIds: undefined
    }));
  }, [setMigrationInfo]);

  useEffect(() => {
    setIsValid(!_.isEmpty(migrationInfo.targetModel));
  }, [migrationInfo.targetModel, setIsValid]);

  return (
    <SimpleTable
      isLoading={_.isEmpty(models)}
      data={models}
      columns={columns}
      rowSelection={RowSelection.SINGLE}
      selectedRows={selectedModel}
      onSelectedRows={onSelectedRows}
      sortBy={DefaultSortBy}
      hasError={hasError}
      errorText={T.admin.model.list.error}
      compact
    />
  );
};

export default NewModelStep;
